import { render, staticRenderFns } from "./detialInventory.vue?vue&type=template&id=144b43fa&scoped=true&"
import script from "./detialInventory.vue?vue&type=script&lang=js&"
export * from "./detialInventory.vue?vue&type=script&lang=js&"
import style0 from "./detialInventory.vue?vue&type=style&index=0&id=144b43fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b43fa",
  null
  
)

export default component.exports